<template>
  <li class="border-gray-400 w-full">
    <div class="relative w-full bg-white transition duration-500  dark:bg-gray-800 rounded-md  flex flex-col lg:flex-row space-y-3 lg:space-y-0 justify-between p-3" :class="cssCard">
      <span class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-20 text-5xl">#{{ rac.idRac }}</span>
      <div class="w-10/12 flex flex-col space-y-2">
        <div class="font-medium dark:text-white">
          Causa
        </div>
        <div class="dark:text-gray-200 text-sm">
          {{ causa }}
        </div>


        <div class="font-medium dark:text-white ">
          Observação
        </div>
        <div class="dark:text-gray-200 text-sm">
          {{ obs }}
        </div>
      </div>
      <div class="w-full lg:w-2/12 flex flex-col space-y-2">
        <div class="font-medium dark:text-white">
          Aberto em
        </div>
        <div class="dark:text-gray-200 text-sm">
          {{ dtAbertura }}
        </div>
        <div class="font-medium dark:text-white">
          Situação
        </div>
        <div class="dark:text-gray-200 text-sm">
          {{ situacao }}
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { DateTime } from 'luxon'
export default {
  name:  'ItemRac',
  props: {
    rac: Object,
  },
  computed: {
    causa(){
      return this.rac.sistemas?.problema?.causa?.nome ?? '-'
    },
    obs(){
      return this.rac.sistemas?.problema.obs ?? '-'
    },
    situacao(){
      return !this.rac.dtHrAbertura ? 'Aberto' : 'Finalizado'
    },
    dtAbertura(){
      return this.rac.dtHrAbertura ? DateTime.fromSQL(this.rac.dtHrAbertura).toFormat('dd/MM/yyyy HH:mm') : '-'
    },
    cssCard(){
      return {
        'border-l-2 border-green-600': this.situacao == 'Finalizado',
        'border-l-2 border-gray-600': this.situacao == 'Aberto',
      }
    },
  },
}
</script>

<style>

</style>
